<template>
<div @mouseleave="searchFocus">
	<!-- Desktop search -->
  <div v-if="isDesktop">
    <input type="search"
      id="search"
      class='search-input'
      placeholder="What are you looking for?"
      v-model="value"
      @keyup="search"
      autocomplete="off"
      @input="!bannerPlaceHolderForSearchSuggestions && autosuggest()"
      @focusout="resetWidthIncrementHandler()"
      @focusin="searchHistoryHandler()"
    />
    <div id="searchCopy"
      style="width: auto;display: inline-block;visibility: hidden;position: fixed;
      overflow:auto;font-size: 14px;"
    />
    <label v-if="showImageSearchWeb && enableVincenzeSearch && isSelectedCountryIndia" class="camera-icon">
      <input type="file" class="d-none" @change="imageSearchHandler($event)" accept="image/*">
      <i class="fa fa-camera"></i>
    </label>
    <span v-if="isSearchMikeShow" class="fa fa-microphone mic-icon" :class="isSpeechRecognising ? 'mic-icon-red': ''" @click="startDictation"/>
    <img v-if="!isExclusive" src='https://prod-img.thesouledstore.com/static/search-white.png' alt="search"  class="search-white icon" @click="submitSearch" :class="[isSearchMikeShow ? 'search-btn-margin': '', !['supimaMenu', 'winterWearMenu', 'activeWearMenu'].includes(callerComp) ? 'dnone': '']"/>
    <span class="d-flex icon" v-if="isExclusive">
      <img v-if="isNewSearch" src="https://prod-img.thesouledstore.com/static/search-black.svg" alt="search" width="18" height="20" @click="submitSearch" />
      <img v-else src="https://prod-img.thesouledstore.com/static/mship-search.svg" @click="submitSearch" alt="search" width="20" height="24" />
    </span>
    <div v-else >
      <span v-if="isNewSearch" class="fa icon mr-1" @click="submitSearch" :class="[isSearchMikeShow ? 'search-btn-margin': '', ['supimaMenu', 'winterWearMenu', 'activeWearMenu'].includes(callerComp) ? 'dnone': '']">
        <img src="https://prod-img.thesouledstore.com/static/search-black.svg" alt="search" width="18" height="20" />
      </span>
      <span v-else class="fa fa-search icon" @click="submitSearch" :class="[isSearchMikeShow ? 'search-btn-margin': '', ['supimaMenu', 'winterWearMenu', 'activeWearMenu'].includes(callerComp) ? 'dnone': '']"/>
    </div>
    <autoCompleteList :trigger="trigger"
      :categories="this.bannerPlaceHolderForSearchHistory && this.isSearchHisDisplay ? this.searchHistoryCategories : this.categories"
      :heightClass="heightVal"
      :searchListWidth="searchListWidth"
      :isSearchHistory="this.bannerPlaceHolderForSearchHistory && this.isSearchHisDisplay"
      :isShowTopSellProduct="isShowTopSellProduct && isSearchTopSellingProductShow"
      :isShowNewArrivalProduct="isShowNewArrivalProduct && isSearchNewArrivalProductShow"
      @demo="demo"
      @searchEventHandler="searchHistoryResponder($event)"/>
  </div>
  <!-- Mobile search -->
  <div v-if="!isDesktop">
    <div class="search-container">
      <div class="search-input">
      <span class="fa fa-arrow-left search-input-icons" @click="searchBack()"/>
      <label v-if="showImageSearchMSite && enableVincenzeSearch && isSelectedCountryIndia" class="camera-icon ml-2 mr-2">
        <input type="file" class="d-none" @change="imageSearchHandler($event)" accept="image/*">
        <i class="fa fa-camera"></i>
      </label>
       <input type="search" id="search" class="searchinput" :class="isSearchMikeShow ? 'search-input-w-65' : ''" 
        placeholder="Search for Products?" v-model="value" 
        @keyup="search" autocomplete="off" 
        @input="!bannerPlaceHolderForSearchSuggestions && autosuggest()" autofocus
        @focusin="searchHistoryHandler()"/>
      <span class="fa fa-close search-input-icons" v-if="showEraseButton" @click="clearSearch"/>
        <div v-if="isSearchMikeShow" class='micbutton' @click="startDictation">
          <span class="fa fa-microphone mic-icon-mobile" :class="isSpeechRecognising ? 'mic-icon-red': ''"/>
        </div>
        <div class="searchbutton" @click="submitSearch">
          <span class="fa fa-search search-input-icons" />
        </div>
      <autoCompleteList :trigger="trigger" 
      :categories="this.bannerPlaceHolderForSearchHistory && this.isSearchHisDisplay ? this.searchHistoryCategories : this.categories"
      :heightClass="heightVal" 
      :searchListWidth="searchListWidth"
      :isSearchHistory="this.bannerPlaceHolderForSearchHistory && this.isSearchHisDisplay"
      :isShowTopSellProduct="false"
      :isShowNewArrivalProduct="false"
      @demo="demo"
      @searchEventHandler="searchHistoryResponder($event)"/>

      </div>
      <!-- Added loader -->
      <div v-if="loading" class='spinner-3-wrapper'>
        <img :src="staticImgServer + 'assets/spinner-3.gif'" class='spinner-3' alt="Loader"/>
        <p class='loading-txt'>Awesomeness Loading</p>
      </div>
    <!-- You may be interested in section  -->
    <div v-if="!loading" class="recommendations-section">
      <!-- New Arrival -->      
		<div class="search-containers" v-if="isSearchNewArrivalProductShow && autoSuggestRecomProduct && autoSuggestRecomProduct.new_arrival_products && autoSuggestRecomProduct.new_arrival_products.length">
      	<h4 class="search-page-headers">New Launches</h4>
        <div class="row product-card-slide">
          <div  v-for="(newProducts, index) in autoSuggestRecomProduct.new_arrival_products" :key="index" class="search-product-cards col-6">
            <img-block
              v-if="newProducts.images" :parry="newProducts.images"
              :imageH="400" :imageW="300" :urlKey="newProducts.product_slug"
              :productTitle="newProducts.product" :isStockConfig="newProducts.prodQty"
              :pstock="newProducts.stock" :jitValue="newProducts.jitValue" :listCat="newProducts.category.name" :productCat="newProducts.artist"
              :productPrice="newProducts.price"
              :exclusivePrice="newProducts.exclusivePrice" :spprice="newProducts.splPrice || newProducts.spl_price" :scrollToProduct="scrollNow"
              class="product-card-img-block" :showImageBlurSoldOutDesign="true"
              @click.native="searchNewArrivalProductClickEvent(newProducts)"
              callerComp="Search Suggestions"
            >
            </img-block>
          </div>
        </div>
      </div>
        <!-- Top Selling Products -->
		<div class="search-containers" v-if="isSearchTopSellingProductShow && autoSuggestRecomProduct && autoSuggestRecomProduct.top_selling_products && autoSuggestRecomProduct.top_selling_products.length">
      	<h4 class="search-page-headers">Trending Products</h4>
        <div class="row product-card-slide">
          <div  v-for="(newProducts, index) in autoSuggestRecomProduct.top_selling_products" :key="index" class="search-product-cards col-6">
            <img-block
              v-if="newProducts.images" :parry="newProducts.images"
              :imageH="400" :imageW="300" :urlKey="newProducts.product_slug"
              :productTitle="newProducts.product" :isStockConfig="newProducts.prodQty"
              :pstock="newProducts.stock" :jitValue="newProducts.jitValue" :listCat="newProducts.category.name" :productCat="newProducts.artist"
              :productPrice="newProducts.price"
              :exclusivePrice="newProducts.exclusivePrice" :spprice="newProducts.splPrice || newProducts.spl_price" :scrollToProduct="scrollNow"
              class="product-card-img-block" :showImageBlurSoldOutDesign="true"
              @click.native="searchTopSellingProductClickEvent(newProducts)"
              callerComp="Search Suggestions"
            >
            </img-block>
          </div>
        </div>
      </div>


			<!-- <div class="search-containers" v-if="newArrival && newArrival.products && newArrival.products.length">
      <h4 class="search-page-headers">New Arrival</h4>
        <div class="row product-card-slide">
          <div  v-for="(newProducts, index) in this.newArrival.products" :key="index" class="search-product-cards col-6">
            <img-block
              v-if="newProducts.images" :parry="newProducts.images"
              :imageH="400" :imageW="300" :urlKey="newProducts.product_slug"
              :productTitle="newProducts.product" :isStockConfig="newProducts.prodQty"
              :pstock="newProducts.stock" :jitValue="newProducts.jitValue" :listCat="newProducts.category.name" :productCat="newProducts.artist"
              :productPrice="newProducts.price"
              :exclusivePrice="newProducts.exclusivePrice" :spprice="newProducts.splPrice" :scrollToProduct="scrollNow"
              class="product-card-img-block" :showImageBlurSoldOutDesign="true"
              @click.native="searchNewArrivalProductClickEvent(newProducts)"
              callerComp="Search Suggestions"
            >
            </img-block>
          </div>
        </div>
      </div> -->
      <!--Recently Viewed-->
      <!-- <div class="search-containers" v-if="this.recentlyViewed.length > 0">
        <h4 class="search-page-headers">Recently Viewed</h4>
        <div class="row product-card-slide">
          <div  v-for="recentlyViewedItem in this.recentlyViewed" v-bind:key="recentlyViewedItem" class="search-product-cards col-6">
            <img-block v-if="recentlyViewedItem.images" :parry="recentlyViewedItem.images" :imageH="400" :imageW="300" :urlKey="recentlyViewedItem.product_slug"
            :productTitle="recentlyViewedItem.product" :isStockConfig="recentlyViewedItem.prod_qty" :pstock="recentlyViewedItem.stock" :productCat="recentlyViewedItem.category"  :productPrice="recentlyViewedItem.price"
            :exclusivePrice="recentlyViewedItem.exclusive_price" :spprice="isExclusive ? recentlyViewedItem.exclusive_price : recentlyViewedItem.spl_price" :scrollToProduct="scrollNow" class="product-card-img-block"></img-block>
          </div>
        </div>
      </div> -->

    <!-- Forgot something in your bag section -->
      <div v-if ="!bannerPlaceHolderForSearchWidgets && _cart && _cart.products && _cart.products.items && _cart.products.items.length" class="search-containers">
      <h4 class="search-page-headers">Forgot something in your bag ?</h4>
        <div class="forgot-something">
          <span class="forgot-something-wrapper" @click="productClick(_cart.products.items[0].category_id === 611 ? '/exclusive': _cart.products.items[0].url_key, _cart.products.items[0])">
            <div class="forget-something-img-block">
              <img :data-src="IMG_URL + path + this._cart.products.items[0].images[0]" alt="Forgot Something"/>
            </div>
            <span class="forget-something-product-details">
              <p class="cartItem-product-name">{{this._cart.products.items[0].product}}</p>
              <p class="cartItem-product-category">{{this._cart.products.items[0].category}}</p>
              <span v-if="this._cart.products.items[0].spl_price">
                <span class="cartItem-special-price">₹ {{this._cart.products.items[0].spl_price}}</span>
                <span class="cartItem-product-price">₹ {{this._cart.products.items[0].price}}</span>
              </span>
              <span v-else>₹ {{this._cart.products.items[0].price}}</span>
            </span>
          </span>
        <button class="btn btn-secondary  btn-block pointer text-uppercase view-bag" type="button" @click="goToCart()">View Bag</button>
        </div>
      </div>
    </div>
    </div>
  </div>
</div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import imgBlock from './imgBlock.vue'
  import Loader from './loader.vue'
  import autoCompleteList from './autoCompleteList.vue'
  var $ = require('jquery')
  import Vue from 'vue'
  window.jQuery = $

  export default {
    props: [ 'searchTerm', 'callerComp', 'isNewSearch' ],
    name: 'autocomplete',
    components: {imgBlock, Loader, autoCompleteList},
    data () {
      return {
        trigger: false,
        value: this.$store.getters.getSearchKey,
        autosuggestpath: process.env.PRODUCT_IMG,
        staticImg: process.env.STATIC_IMG,
        showEraseButton: false,
        IMG_URL: process.env.IMG_BASE_URL,
        imgSize: `cdn-cgi/image/width=300,height=400,quality=100/`,
        path: process.env.PRODUCT_IMG,
        loading: false,
        heightVal: null,
        speechRecognition: '',
        isSpeechRecognising: false,
        isSpeechRecogBrowserSupport: false,
        searchListWidth: 260,
        isDesktop: this.$parent && this.$parent.$parent && this.$parent.$parent.$parent && this.$parent.$parent.$parent.isDesktop,
        staticImgServer: process.env.STATIC_IMG_SERVER2,
        searchHistoryCategories: [],
        isSearchHisDisplay: false,
        isShowTopSellProduct: false,
        isShowNewArrivalProduct: false
      }
    },
    mounted: function () {
      if (this.webcategory && !this.bannerPlaceHolderForSearchWidgets) {
        this.loading = true
        const payload = {
          genderType: this.webcategory === 'women' ? 2 : 1
        }
        this.$store.dispatch('NEW_ARRIVAL', payload)
      }
      let eventHandler = function () {
        if (window.scrollY >= 19) {
          $('.autocomplete-wrapper').hide()
          $('.searchinput').val('')
        }
      }
      if (this.$route.name === 'search' && this.$route.query && this.$route.query.q) {
        this.$store.dispatch('setSearchPageKey', this.$route.query.q)
        this.value = this.$route.query.q
      }
      window.addEventListener('scroll', eventHandler)

      // web speech initiation
      if (window.hasOwnProperty('webkitSpeechRecognition')) {
        this.isSpeechRecogBrowserSupport = true
        // eslint-disable-next-line new-cap
        const recognition = new window.webkitSpeechRecognition()
        recognition.continuous = false
        recognition.interimResults = true
        this.speechRecognition = recognition
        const _this = this

        recognition.onstart = function (e) {
          _this.isSpeechRecognising = true
        }

        recognition.onresult = function (e) {
          const inputValue = e.results[0][0].transcript
          document.getElementById('search').value = inputValue
          _this.value = inputValue
        }
        recognition.onend = function (e) {
          _this.submitSearch()
          _this.isSpeechRecognising = false
        }
        recognition.onerror = function (e) {
          recognition.stop()
        }
      }
      if (!this.$parent.isDesktop) {
        this.$store.commit('SET_FOOTER_COLLAPSE_CONTROL', {
          expanded: true,
          expandedClass: 'show', // '' or show
          bottomStyle: 'margin-bottom: 0px;'
        })
      }
    },
    watch: {
      newArrival () {
        if (this.newArrival && this.newArrival.products && this.newArrival.products.length) {
          this.loading = false
        }
      },
      webcategory (value) {
        if (value && !this.bannerPlaceHolderForSearchWidgets) {
          this.loading = true
          const payload = {
            genderType: value === 'women' ? 2 : 1
          }
          this.$store.dispatch('NEW_ARRIVAL', payload)
        }
      }
    },
    computed: {
      ...mapGetters(['autoSuggest', '_cart', 'product', 'user', 'authStatus', 'newArrival', 'isExclusive', 'exclusiveUser', 'recentlyViewed', 'unbxdElasticSearchType', 'exclusiveDetails', 'bannerPlcaeHolderData', 'webcategory', 'autoSuggestRecomProduct', 'isSelectedCountryIndia']),
      categories: function () {
        let allDoctypes = new Set(this.autoSuggest.map(category => category.doctype))
        allDoctypes = [...allDoctypes]
        const newDoctypes = []
        newDoctypes.push('TOP_SEARCH_QUERIES')
        if (allDoctypes.find(category => category === 'category')) {
          newDoctypes.push('category')
        }
        if (allDoctypes.find(category => category === 'product')) {
          newDoctypes.push('product')
        }
        if (allDoctypes.find(category => category === 'artist')) {
          newDoctypes.push('artist')
        }
        return newDoctypes.map(name => ({
          name: name.replace(/_/g, '  '),
          list: this.getFiltered(name)
        }))
      },
      isSearchMikeShow: function () {
        const hideSearchMikeBannerObj = this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
            bannerData.product_type.toLowerCase() === 'HIDE_SEARCH_MIKE_WEB'.toLowerCase())
        return this.isSpeechRecogBrowserSupport && !hideSearchMikeBannerObj
      },
      bannerPlaceHolderForSearchSuggestions: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
          bannerData.product_type.toLowerCase() === 'HIDE_SEARCH_SUGGESTIONS_WEB'.toLowerCase())
      },
      bannerPlaceHolderForSearchWidgets: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
          bannerData.product_type.toLowerCase() === 'HIDE_SEARCH_WIDGETS_WEB'.toLowerCase())
      },
      bannerPlaceHolderForSearchHistory () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
          bannerData.product_type.toLowerCase() === 'SEARCH_HISTORY_DATA_WEB'.toLowerCase())
      },
      isSearchNewArrivalProductShow: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
            bannerData.product_type.toLowerCase() === 'SEARCH_NEW_ARRIVAL_PRODUCT_WEB'.toLowerCase())
      },
      isSearchTopSellingProductShow: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
            bannerData.product_type.toLowerCase() === 'SEARCH_TOP_SELLING_PRODUCT_WEB'.toLowerCase())
      },
      enableVincenzeSearch: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Search Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_VINCENZE_SEARCH'.toLowerCase())
      },
      showImageSearchWeb () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for === 'Home Screen Page' && bannerData.status === true && bannerData.product_type === 'SHOW_IMAGE_SEARCH_WEB')
      },
      showImageSearchMSite () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for === 'Home Screen Page' && bannerData.status === true && bannerData.product_type === 'SHOW_IMAGE_SEARCH_MOBILE_SITE')
      }
    },
    methods: {
      demo (autoSuggestArgArr) {
        let value = ''
        let uniqueID = 0
        if (autoSuggestArgArr.length > 0) {
          value = autoSuggestArgArr[0]
          uniqueID = autoSuggestArgArr[1]
        }
        this.$store.commit('GTAG_EVENT', {eventName: 'searchResultListItem_click', payload: {route: Vue.ls.get('routeObj'), searchResult: value}})
        this.$store.commit('SET_NAVIGATION_WIDGET', 'Autosuggest List Item Click')
        let autosuggestedDetails = this.autoSuggest.find(e => (e.uniqueId === uniqueID))
        if (autosuggestedDetails.productUrl === 'the-souled-store-exclusive' || autosuggestedDetails.productUrl === 'the-souled-store-exclusive-99' || autosuggestedDetails.productUrl === 'the-souled-store-exclusive-3month' || autosuggestedDetails.productUrl === 'the-souled-store-exclusive-11' || autosuggestedDetails.productUrl === 'the-souled-store-exclusive-9' || autosuggestedDetails.productUrl === 'the-souled-store-exclusive-12-months' || autosuggestedDetails.productUrl === 'the-souled-store-exclusive-90') {
          this.$router.push('/exclusive')
        } else if (autosuggestedDetails.productUrl) {
          this.$router.push('/product/' + autosuggestedDetails.productUrl)
        } else {
          this.$router.push('/search?q=' + autosuggestedDetails.autosuggest)
        }
        this.trigger = false
        this.value = ''
      },
      scrollNow: function () {
        window.scrollTo(0, 0)
      },
      search: function (e) {
        if (!this.value) {
          this.value = ''
          this.searchHistoryHandler()
        } else {
          this.isSearchHisDisplay = false
          this.isShowTopSellProduct = false
          this.isShowNewArrivalProduct = false
          if (e.keyCode === 13) {
            this.$store.commit('SET_NAVIGATION_WIDGET', 'User custom search')
            this.$store.dispatch('setSearchPageKey', this.value)
            this.$router.push('/search?q=' + this.value)
          }
        }
      },
      searchFocus () {
        this.$store.commit('GTAG_EVENT', {eventName: 'search_icon', payload: {}})
        if (!this.bannerPlaceHolderForSearchHistory) {
          this.trigger = false
          this.isSearchHisDisplay = false
          this.isShowTopSellProduct = false
          this.isShowNewArrivalProduct = false
        }
      },
      submitSearch: function () {
        if (this.value) {
          this.$store.commit('SET_NAVIGATION_WIDGET', 'User custom search')
          this.$router.push('/search?q=' + this.value)
        }
      },
      clearSearch: function () {
        this.value = ''
        this.trigger = false
      },
      autosuggest: function () {
        if (this.value && this.value.length > 1) {
          this.showEraseButton = true
        } else {
          this.showEraseButton = false
        }
        if (this.value && this.value.length > 1) {
          const payload = {
            keyword: this.value,
            is_exclusive: this.isExclusive || this.exclusiveUser ? 1 : 0,
            show_upgrade: this.exclusiveDetails && this.exclusiveDetails.show_upgrade_plan ? 1 : 0,
            countryId: this.$store.state.selectedCountryAddress.countryId
          }
          $('.autocomplete-wrapper').show()
          this.$store.dispatch('AUTOSUGGEST_PRODUCTS', {payload, unbxdElasticSearchType: {...this.unbxdElasticSearchType}})
          let autoSuggestLen = JSON.parse(JSON.stringify(this.autoSuggest))
          autoSuggestLen = autoSuggestLen && autoSuggestLen.length
          // this.heightVal = this.categories.length === 2 ? 'singleItem' : 'multipleItem'
          this.heightVal = this.listLength(this.categories)
          this.trigger = !!autoSuggestLen
        } else {
          this.trigger = false
        }
        this.searchWidthIncrementHandler()
      },
      searchWidthIncrementHandler: function () {
        // Here 90: padding of input, 260: is static width, 500 max width limit
        // this.searchListWidth is passed as prop
        let elem = $('#search') && $('#search')[0]
        let elemCopy = $('#searchCopy') && $('#searchCopy')[0]
        if (elem && elemCopy) {
          elemCopy.innerText = elem.value
          let widthAquired = elemCopy.clientWidth + 90
          widthAquired && widthAquired > 500 ? widthAquired = 500 : ''
          widthAquired && widthAquired > 260 ? elem.style.width = widthAquired + 'px' : elem.style.removeProperty('width')
          widthAquired && widthAquired > 260 ? this.searchListWidth = widthAquired : this.searchListWidth = 260
        }
      },
      resetWidthIncrementHandler: function () {
        let elem = $('#search') && $('#search')[0]
        elem && elem.style.removeProperty('width')
        this.searchListWidth = 260
        if (this.bannerPlaceHolderForSearchHistory) {
          setTimeout(() => {
            this.trigger = false
            this.isSearchHisDisplay = false
            this.isShowTopSellProduct = false
            this.isShowNewArrivalProduct = false
          }, 200)
        }
      },
      listLength: function (cat) {
        let i
        let n = 0
        for (i = 0; i < cat.length; i++) {
          n += cat[i].list.length
        }
        return n <= 7 ? 'singleItem' : 'multipleItem'
      },
      getFiltered: function (cat) {
        let filtered = this.autoSuggest
        .filter(doctype => doctype.doctype === cat)
        .filter(category => {
          if (!category.category || !category.category.length) {
            return true
          }
          return (category.category.indexOf('Packaging Materials') === -1)
        })
        return filtered
      },
      getCategoryWiseImage: function (doctype) {
        switch (doctype) {
          case 'TOP_SEARCH_QUERIES':
            return this.staticImg + 'icons/iconfinder_trending-up_2561482 (2).png'
        }
      },
      searchBack: function () {
        window.history.back()
      },
      productClick: function (productUrl, product) {
        this.$store.commit('GTAG_EVENT', {eventName: `forgetSomethingProduct_click`, payload: {route: Vue.ls.get('routeObj'), product: product}})
        if (productUrl === '/exclusive') {
          this.$router.push(productUrl)
        } else {
          this.$router.push('product/' + productUrl)
        }
      },
      goToCart: function () {
        this.$router.push('/cart')
      },
      startDictation: function () {
        this.$store.commit('GTAG_EVENT', {eventName: 'ga_mic_click', payload: {route: Vue.ls.get('routeObj')}})
        this.$store.commit('GTAG_EVENT', {eventName: 'ct_mic_click', payload: {route: Vue.ls.get('routeObj')}})
        if (this.isSpeechRecognising) {
          this.speechRecognition.stop()
          return
        }
        this.speechRecognition.lang = 'en-US'
        this.speechRecognition.start()
      },
      searchNewArrivalProductClickEvent (product) {
        this.$store.commit('GTAG_EVENT', {eventName: `searchNewArrivalProduct_click`, payload: {route: Vue.ls.get('routeObj'), product: product}})
      },
      searchTopSellingProductClickEvent (product) {
        this.$store.commit('GTAG_EVENT', {eventName: `searchTopSellingProduct_click`, payload: {route: Vue.ls.get('routeObj'), product: product}})
      },
      searchHistoryHandler () {
        this.searchHistoryCategories = Vue.ls.get('searchHistory')
        if (this.searchHistoryCategories && !this.authStatus) {
          this.searchHistoryCategories[0].name = 'Popular Searches'
        }
        if (this.bannerPlaceHolderForSearchHistory && !this.value.length) {
          this.isSearchHisDisplay = true
          this.trigger = true
        }
        /** Disptach action for getting selling and new arrival products */
        if (this.isSearchTopSellingProductShow || this.isSearchNewArrivalProductShow) {
          this.$store.dispatch('GET_RECOMMENDED_PRODUCT', {})
          this.trigger = true
          this.isShowTopSellProduct = true
          this.isShowNewArrivalProduct = true
        }
      },
      searchNewArrivalTopSelProduct () {
        this.$store.dispatch('GET_RECOMMENDED_PRODUCT', {})
        this.isShowTopSellProduct = true
        this.isShowNewArrivalProduct = true
        this.trigger = true
      },
      searchHistoryResponder (searchValue) {
        this.value = searchValue
        this.search({keyCode: 13})
      },
      imageSearchHandler (event) {
        const searchedFile = event.target.files && event.target.files[0]
        if (searchedFile) {
          // File size validation: Limit to 5MB
          const maxSize = 5 * 1024 * 1024 // 5MB
          if (searchedFile.size > maxSize) {
            Vue.toasted.show(
              `File size exceeds 5MB. Please select a smaller file.`,
              {
                theme: 'primary',
                className: 'toasted-customred',
                position: 'top-right',
                duration: 5000
              }
            )
            event.target.value = '' // Reset the input
            return
          }
          // File type validation: Allow only JPEG, PNG, and GIF
          const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
          if (!allowedTypes.includes(searchedFile.type)) {
            Vue.toasted.show(
              ` Only JPEG, WEBP, PNG, and GIF files are allowed.`,
              {
                theme: 'primary',
                className: 'toasted-customred',
                position: 'top-right',
                duration: 5000
              }
            )
            event.target.value = '' // Reset the input
            return
          }
          // Proceed with image search logic
          Vue.ls.set('image_features', null)
          this.$store.commit('SET_IMAGE_SEARCH_DATA', searchedFile)
          this.$store.commit('SET_IMAGE_RESPONSE_DATA', null)
          this.$store.commit('SET_NEW_IMAGE_SEARCH', true)
          this.$store.dispatch('setSearchPageKey', 'imageSearch')
          this.value = this.$store.getters.getSearchKey
          this.$router.push('/search?q=imageSearch')
        }
      }
    },
    beforeDestroy () {
      window.removeEventListener('scroll', this.eventHandler)
    },
    destroyed () {
      this.$store.dispatch('setSearchPageKey', '')
    }
  }
</script>
<style scoped>

.search-input-icons {
  font-size: 15px;
}

.search-product-cards {
  height: auto;
  margin: 0.5rem;
  background: white;
  position: relative;
  border-radius: 5px;
  box-shadow: 0 2px 6px rgba(0,0,0,.2);
  padding: 0px !important;
}

.product-card-slide {
  flex-wrap: nowrap;
  overflow-y: scroll;
  margin: 0.2rem;
}

.search-containers {
  border: 1px solid transparent;
  background: white;
  overflow: hidden;
}

.search-page-headers {
  font-size: 18px;
  padding: 0.6rem;
  color:#272c3f;
}

.forgot-something {
  margin: 0rem 0.5rem 0.5rem;
}

.forgot-something-wrapper {
  display: flex;
  padding: 0.2rem 0rem 1rem;
}

.forget-something-img-block {
  margin-right: 1rem;
  width: 126px;
  box-shadow: 0 2px 6px rgba(0,0,0,.2);
}

.forget-something-product-details p{
  margin-bottom: 0;
}

.view-bag {
  border: 1.5px solid #3a8c8d;
  border-radius: 0px;
  color: #3a8c8d;
}

.cartItem-product-name {
  display: block;
  font-size: 17px;
  overflow: hidden;
  white-space: nowrap;
  font-weight: bold;
  color:#525963;
}

.cartItem-product-category {
  color:#9fa1a6;
}

.cartItem-special-price {
  color: #ed2d2f;
}

.cartItem-product-price {
  color: #ccc;
  text-decoration: line-through;
  margin-left: 5px;
  font-size: 12px;
}

.clearButton {
  font-size: 16px;
}

.search {
  vertical-align: middle;
  white-space: nowrap;
  position: relative;
}

.search input#search,
.mbinput input#search {
  width: 40px;
  height: 40px;
  font-size: 14px;
  float: right;
  padding-left: 40px;
  border-radius: 5px;
  color: #262626;
  border: 1px solid transparent;
  transition: width .55s ease;
}
.new-search input#search,
.mbinput input#search {
  width: 279px;
  border-radius: 87px;
  border: 1px solid #323232;
  padding-left: 15px;
  padding-right: 90px;
}

.new-search .mic-icon,
.new-search .camera-icon {
  display: inline;
}
.supima-menu .search input#search {
  background-color:#e11b23;
}
.winter-menu .search input#search {
  background-color:#e11b23;
}

.activewear-menu .search input#search {
  background-color:#000000;
}

.mbinput input#search {
  width: 100%;
}

.search .icon {
  position: absolute;
  font-size: 22px;
  margin-top: 8px;
  z-index: 1;
  color: #4f5b66;
  right: 15px;
}
.search .search-white {
  width: auto;
  height: 24px;
}
.search-btn-margin{
  right: 9px !important;
}

.search .mic-icon {
  display: none;
  position: absolute;
  font-size: 22px;
  margin-top: 10px;
  z-index: 1;
  color: #4f5b66;
  right: 42px;
  text-align: right;
}

.new-search .mic-icon {
  display: inline;
}

.search .camera-icon {
  display: none;
  position: absolute;
  cursor: pointer;
  font-size: 20px;
  margin-top: 7px;
  z-index: 1;
  color: #4f5b66;
  right: 67px;
  text-align: right;
}

.mic-icon-mobile{
  font-size: 15px;
  margin-top: 3px;
}
.mic-icon-red {
  color: red !important;
}

.mbinput .icon {
  display: none;
}

.search input#search:focus,
.search input#search:active {
  outline: none;
  width: 260px;
  padding-left: 15px;
  background: #eee;
}

.search:hover input#search,
.search input#search:focus {
  width: 260px;
  padding-left: 15px;
  padding-right: 90px;
  background: #eee;
}

.new-search:hover input#search,
.new-search input#search:focus {
  width: 279px;
  padding-left: 15px;
  padding-right: 90px;
  background: #fff;
}

.search:hover .mic-icon,
.search:hover .camera-icon {
  display: inline;
}
.search:hover .icon{
  color: #4f5b66;
  display: inline !important;
} 
.search:hover .search-white {
  display: none;
}

.mbinput .autocomplete {
  width: 100%;
}

.searchbutton {
  float: right;
}
.micbutton {
  float: right;
  margin-left: 1.5rem;
  margin-right: 1rem;
}

.searchinput {
  width: 80%;
  border: 0;
  outline:none;
  padding-left: 1rem;
}
.search-input-w-65{
  width: 65% !important;
}

.recommendations-section {
  padding-top: 1rem;
}

@media screen and (max-width: 991px) {
  .search-input {
    width: 100%;
    background: #fff;
    box-shadow: 0 0 5px #a7a9ac;
    padding: .9rem .9rem 1rem .8rem;
  }
  .micbutton:active,
.searchbutton:active,
.search-input-icons:active {
  transform: scale(1.25);
  transition: transform 0.2s ease, background-color 0.2s ease;
}
  .product-card-img-block {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .search-input .camera-icon {
    float: right;
  }
}
@media (max-width: 1200px) {
  .new-search input#search,
  .mbinput input#search {
    width: 210px;
  }
  .new-search:hover input#search,
  .new-search input#search:focus {
    width: 210px;
  }
}
</style>
<style>
.exclusive .search:hover .icon {
  display: flex !important;
}
</style>



// WEBPACK FOOTER //
// autocomplete.vue?4a8409ce